export const InputFields = {
  'E4': {
    index: 1,
    title: 'Материал',
    value: undefined,
    ei: '',
  },
  'E5': {
    index: 2,
    title: 'Кажущаяся плотность материала (удельный вес)',
    value: undefined,
    ei: 'кг/м3',
  },
  'E6': {
    index: 3,
    title: 'Объемная (насыпная ) масса материала',
    value: undefined,
    ei: 'кг/м3',
  },
  'E7': {
    index: 4,
    title: 'Влажность материала до сушки(абсолютная)',
    value: undefined,
    ei: '%',
  },
  'E8': {
    index: 5,
    title: 'Влажность материала после сушки(абсолютная)',
    value: undefined,
    ei: '%',
  },
  'E9': {
    index: 6.1,
    title: 'По какому продукту считается производительность',
    value: undefined,
    ei: '',
    type: 'select',
    options: [
      'По сухому',
      'По влажному'
    ],
  },
  'E10': {
    index: 6.2,
    title: 'Производительность',
    value: undefined,
    ei: 'т/ч',
  },
  'E11': {
    index: 7,
    title: 'Взаимное направление движения газа и материала в сушилке',
    value: undefined,
    ei: '',
    type: 'select',
    options: [
      'Прямоточное',
      'Противоточное'
    ],
  },
  'E12': {
    index: 1,
    title: 'Выбор технологии обработки',
    value: undefined,
    ei: '',
    type: 'select',
    options: [
      'Обжиг (прокалка)',
      'Сушка'
    ],
  },
  'E13': {
    index: 8,
    title: 'Температура материала до сушилки',
    value: 0,
    ei: 'град',
  },
  'E14': {
    index: 9,
    title: 'Температура материала после сушилки',
    value: 100,
    ei: 'град',
  },
  'E15': {
    index: 11,
    title: 'Температура газа на входе в сушилку',
    value: 1200,
    ei: 'град',
  },
  'E16': {
    index: 12,
    title: 'Температура газа на выходе из сушилки',
    value: 200,
    ei: 'град',
  },
  'E17': {
    index: 1,
    title: 'Время обжига',
    value: undefined,
    ei: 'мин',
  },
  'C19': {
    value: 0,
    title: 'Массовая доля фракций материала с диаметром частиц',
  },
  'D19': {
    value: undefined,
    title: 'Массовая доля фракций материала с диаметром частиц',
  },
  'E19': {
    value: undefined,
    title: 'Массовая доля фракций материала с диаметром частиц',
  },
  // 'C20': {value: 0},'D20': {value: 1},'E20': {value: 0},
  // 'C21': {value: 0},'D21': {value: 1},'E21': {value: 0},
  // 'C22': {value: 0},'D22': {value: 1},'E22': {value: 0},
  // 'C23': {value: 0},'D23': {value: 1},'E23': {value: 0},
  // 'C24': {value: 0},'D24': {value: 1},'E24': {value: 0},
  // 'C25': {value: 0},'D25': {value: 1},'E25': {value: 0},
  // 'C26': {value: 0},'D26': {value: 1},'E26': {value: 0},
  // 'C27': {value: 0},'D27': {value: 1},'E27': {value: 0},
  // 'C28': {value: 0},'D28': {value: 1},'E28': {value: 0},
  // 'C29': {value: 0},'D29': {value: 1},'E29': {value: 0},
  // 'C30': {value: 0},'D30': {value: 1},'E30': {value: 0},
  // 'C31': {value: 0},'D31': {value: 1},'E31': {value: 0},
  'E32': {
    index: 14,
    title: 'Угол естественного откоса материала',
    value: undefined,
    ei: 'град',
  },
  'E33': {
    index: 20,
    title: 'Температура наружного воздуха',
    value: undefined,
    ei: 'град',
  },
  'E34': {
    index: 16,
    title: 'Относительная влажность воздуха',
    value: undefined,
    ei: '%',
  },
  'E35': {
    index: 1,
    title: 'Тип топлива',
    value: undefined,
    ei: '',
    type: 'select',
    options: [
      'Дизель',
      'Природный газ',
      'Уголь',
      'Угольная пыль',
      'СНГ',
      'СПГ',
      'Пропан-бутановая смесь',
    ],
  },
  'E36': {
    index: 21,
    title: 'Теплоемкость абсолютно сухого материала',
    value: undefined,
    ei: 'Дж/(кг*К)',
  },
  'E38': {
    index: 1,
    title: 'Тип насадки на выходе материала из сушки',
    value: 'Лопастная',
    ei: '',
    type: 'select',
    options: [
      'Лопастная',
      'Секторная'
    ],
  },
  'E58': {
    index: 1,
    title: 'Тип передачи',
    value: undefined,
    ei: '',
    type: 'select',
    options: [
      'Зубчатая',
      'Цепная',
      'Фрикционная'
    ],
  },
}
